import { Controller } from '@hotwired/stimulus'

// Modal that closes on backdrop click or Escape key.
// Usage:
//   data-controller="modal"
//   data-action="click->modal#closeOnBackdrop keydown.esc@window->modal#close"
export default class extends Controller {
  static classes = ['open']

  close() {
    this.element.classList.remove(this.openClass || 'modal-open')
  }

  closeOnBackdrop(event) {
    if (event.target === this.element) this.close()
  }
}
